module.exports = __webpack_public_path__ + "static/img/cinemaBottom1.12f51fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cinemaBottom1.png
// module id = kPfL
// module chunks = 2